import { CreationResponse, Ticket, TicketReply } from "@/api/types";
import axios from "axios";

export const getTicket = (id: string) => axios.get<Ticket>(`tickets/${ id }`);
export const setTicketState = (id: number, state: number) => axios.put(`tickets/${ id }/state`, { state });
export const replyTicket = (id: number, body: string) => axios.post<CreationResponse>(`tickets/${ id }/reply`, { body });
export const getReplies = (id: number) => axios.get<TicketReply[]>(`tickets/${ id }/replies`);
export const getTickets = (closed: boolean, filter: string) =>
    axios.get<Ticket[]>('tickets', { params: { closed, filter } });
export const createTicket = (title: string, body: string, category: number) =>
    axios.post<Ticket>('tickets/create', { title, body, category });
export const deleteTicket = (id: number) => axios.delete(`tickets/${ id }`);
export const deleteReply = (id: number) => axios.delete(`tickets/reply/${ id }`);
export const assignTicket = (id: number, userId: number) => axios.put(`tickets/${ id }/assign/${ userId }`);
